import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const threeYearOldKodawariStrong: BlogMetaData = {
  title: '3歳のこだわりが強い子への関わり方｜行動パターン別の見方と声かけ・相談の目安',
  description:
    '3歳のこだわりが強いのは普通？順番・場所・手順・服・切り替えなど行動パターン別に、行動の前後で見るポイントと、家庭で試せる予告・選択肢・声かけ、癇癪との関係、相談の目安を園長が解説します。',
  thumbnailUrl: '/img/blog-3-year-old-kodawari-strong.webp',
  filePath: buildBlogFilePath('3-year-old-kodawari-strong'),
  category: BLOG_CATEGORY.PARENTING,
};
